import { GetterTree } from 'vuex';
import { DocumentEditState } from '../stores/document-edit.store';
import { RootState } from '../store';
import { IRecipient } from '@/types/Recipient';
import EnumRecipientRole from '@/enums/RecipientRole';

export const getters: GetterTree<DocumentEditState, RootState> = {
  signerCount: (state: DocumentEditState): number =>
    getRoleCount(state.recipients, EnumRecipientRole.Signer),
  approverCount: (state: DocumentEditState): number =>
    getRoleCount(state.recipients, EnumRecipientRole.Approver),
};

const getRoleCount = (recipients: IRecipient[], role: EnumRecipientRole): number =>
  recipients.filter((r: IRecipient) => r.role === role).length;
